import { Component, OnInit } from '@angular/core';
import { RelatorioService } from 'src/app/services/relatorio.service';
import { Contratado } from 'src/app/models/contratado.model';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { ContratadoConvenio } from 'src/app/models/contratado-convenio.model';
import { ProfissionalSaude } from 'src/app/models/profissionalSaude.model';
import { FiltroLancamento } from 'src/app/models/filtro-lancamento.model';
import { NgxSpinnerService } from 'ngx-spinner';
import { AuthenticationService } from '../../../services/authentication.service';
import { ComunsService } from '../../../comuns/comuns.service';
import { ETipoGuia } from 'src/app/enum/enums';
import { MessageService } from 'primeng/primeng';

@Component({
  selector: 'app-relatorio-guia',
  templateUrl: './relatorio-guia.component.html',
  styleUrls: ['./relatorio-guia.component.css'],
  providers: [MessageService]
})
export class RelatorioGuiaComponent implements OnInit {

  convenios: Array<ContratadoConvenio>;
  profissionais: Array<ProfissionalSaude>;
  relatorioGuiaForm: FormGroup;
  submitted: boolean = false;

  constructor(
    private messageService: MessageService,
    private authenticationService: AuthenticationService,
    private relatorioService: RelatorioService,
    private formBuilder: FormBuilder,
    private comunsService: ComunsService,
    private spinner: NgxSpinnerService) { }

  ngOnInit() {
    this.form();
  }

  gerarRelatorioGuias() {

    this.submitted = true;
    var contratadoConvenioForm = (<FormGroup>this.relatorioGuiaForm.controls['contratadoConvenioForm']).value;
    let parametros = this.relatorioGuiaForm.value as FiltroLancamento;
    this.setValueForm(parametros, contratadoConvenioForm);
    parametros.dtEmissaoInicial = this.comunsService.transformDate(parametros.dtEmissaoInicial);
    parametros.dtEmissaoFinal = this.comunsService.transformDate(parametros.dtEmissaoFinal);

    if (this.relatorioGuiaForm.invalid) {
      return;
    }

    this.spinner.show();
    this.relatorioService.gerarRelatorioGuias(parametros).subscribe((file) => {
      this.spinner.hide();
      this.submitted = false;
      this.relatorioService.download(file);
    }, (exception: Response) => {
      this.spinner.hide();
      this.messageService.add({ severity: 'success', summary: '', detail: "Nenhum registro encontrado para o período informado." });
      this.submitted = false;
    })
  }

  form() {
    this.relatorioGuiaForm = this.formBuilder.group({
      dtEmissaoInicial: [null, Validators.required],
      dtEmissaoFinal: [null, Validators.required],
      convenioId: [null],
      contratadoId: [null],
      profissionalSaudeId: [null],
      espelho: [true],
      tipoGuiaId: [ETipoGuia.consulta],
      usuario: [this.authenticationService.currentUserValue.user.nomePessoa],
      contratadoConvenioForm: this.formBuilder.group({
        contratado: [null, Validators.required],
        convenio: [null],
        profissionalSaude: [null]
      }),
      guiaSadt: [false],
    })
  }

  receiveContratado(contratado: Contratado) {
    var form = (<FormGroup>this.relatorioGuiaForm.controls['contratadoConvenioForm']);

    if (contratado) {
      this.convenios = contratado.contratadoConvenio;
      this.profissionais = contratado.profissionalSaude;
      form.patchValue({
        contratado: [contratado]
      });
    }
    else {
      form.reset();
      this.convenios = [];
      this.profissionais = [];
    }
  }

  receiveTipoGuia(tipoGuiaId) {
    this.relatorioGuiaForm.patchValue({
      tipoGuiaId: tipoGuiaId
    });
  }

  validacoes = {
    'campoObrigatorio': [
      { type: 'required', message: 'Este campo é obrigatório.' }
    ]
  };

  setValueForm(parametros, contratadoConvenioForm) {
    parametros.contratadoId = contratadoConvenioForm.contratado == null ? null : contratadoConvenioForm.contratado[0].id;
    parametros.convenioId = contratadoConvenioForm.convenio == null ? null : contratadoConvenioForm.convenio.convenioId;
    parametros.profissionalSaudeId = contratadoConvenioForm.profissionalSaude == null ? null : contratadoConvenioForm.profissionalSaude.id;
  }

}
